import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatCardModule } from '@angular/material/card'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatMenuModule } from '@angular/material/menu'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatRadioModule } from '@angular/material/radio'
import { MatSelectModule } from '@angular/material/select'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { MatTooltipModule } from '@angular/material/tooltip'
import { PipesModule } from '@mmx/pipes'
import { DirectivesModule } from '@mmx/shared'
import { TranslateModule } from '@ngx-translate/core'
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search'

import { CopyTextModule } from '../copy-text'
import { EligibilityBenefitDetailsComponent } from './eligibility-benefit-details.component'
import { EligibilityCardComponent } from './eligibility-card.component'
import { EligibilityMessagesComponent } from './eligibility-messages.component'
import { EligibilityStatusComponent } from './eligibility-status/eligibility-status.component'

const components = [
  EligibilityBenefitDetailsComponent,
  EligibilityCardComponent,
  EligibilityMessagesComponent,
]

@NgModule({
  imports: [
    CommonModule,
    CopyTextModule,
    DirectivesModule,
    EligibilityStatusComponent,
    FlexLayoutModule,
    TranslateModule,
    PipesModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSnackBarModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatTooltipModule,
    NgxMatSelectSearchModule,
    ReactiveFormsModule,
  ],
  exports: [...components],
  declarations: [...components],
})
export class EligibilityCardModule { }
